// Icone padrao de sinistro do sistema (emseg-icones-sistema/icons/sinistro.svg).
export default function IconSinistro({ size = 16, style, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      role="img" aria-label="Sinistro" style={{ display: 'block', ...style }} {...props}>
      <path d="M12 3l8 3v5c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-3z" />
      <path d="M12 8v5M12 17h.01" />
    </svg>
  )
}
